import { Hint } from '@/components/ui/Hint';
import cn from '@/utils/cn';

import { useAutoAnimate } from '@formkit/auto-animate/react';
import constate from 'constate';
import { useFormContext } from 'react-hook-form';

const [CardProvider, useCardContext] = constate(
  ({ isDeadEnd }: { isDeadEnd: boolean }) => {
    return {
      isDeadEnd,
    };
  }
);
const Card = ({
  children,
  isDeadEnd = () => false,
  addBorderWhen = () => false,
}: {
  children: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isDeadEnd?: (value: Record<any, any>) => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addBorderWhen?: (val: Record<any, any>) => boolean;
}) => {
  const { watch } = useFormContext();
  const value = watch();

  const [parent] = useAutoAnimate({
    duration: 200,
  });

  return (
    <CardProvider isDeadEnd={isDeadEnd(value) || false}>
      <div
        className={cn(
          'space-y-5.5 overflow-hidden rounded-xlg bg-white p-3.5 lg:p-6',
          (isDeadEnd(value) || false || addBorderWhen(value)) &&
            'border-2 border-yellow-500 p-3 lg:p-[22px]'
        )}
        ref={parent}
      >
        {children}
      </div>
    </CardProvider>
  );
};

export const CardDeadEndHint = ({
  children,
  variant = 'default',
}: {
  children: React.ReactNode;
  variant?: 'default' | 'primary';
}) => {
  const { isDeadEnd } = useCardContext();
  if (!isDeadEnd) return null;
  return <Hint variant={variant}>{children}</Hint>;
};

export default Card;
